// Format a date to DD/MM/YYYY
function formatDate(date) {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().padStart(4, "0");

  return `${day}/${month}/${year}`;
}

// Format date to HH:mm
function formatTime(date) {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
}

// Convert local time to UTC
function convertLocalTimeToUtc(utcDate) {
  const date = new Date(utcDate);

  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
}

// Convert UTC time to local
function convertUtcToLocalTime(localDate) {
  const date = new Date(localDate);

  return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}

// Search a value in an object
function searchValue(object, field) {
  const item =
    object != null ? object.find((item) => item.name === field) : null;

  return item != null ? item.value : null;
}

// Check if device is mobile
function isMobile() {
  return window.innerWidth < 768;
}

// Check if the label should be small
function useSmallAddLabel() {
  return window.innerWidth <= 1024 && window.innerWidth >= 550;
}

// Get the table views depending on the device
function tableViews() {
  let views = [];

  // If device is not mobile, add the table view
  if (!isMobile()) {
    views.push({
      type: "table",
      shownActions: 10, // Number of actions to show in the table before collapsing
    });
  }

  // Add the list view
  views.push({
    type: "list",
    shownActions: 10, // Number of actions to show in the list before collapsing
  });

  return views;
}

function downloadFile(file, name) {
  // Download file.data (from responseType blob)
  const url = window.URL.createObjectURL(new Blob([file.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", name);

  document.body.appendChild(link);

  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Create a random password with 12 chars and at least, one punctuation, one number and one letter
function createRandomPassword() {
  function getRandomChar(characters) {
    return characters.charAt(Math.floor(Math.random() * characters.length));
  }

  function shuffleString(string) {
    let array = string.split("");
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array.join("");
  }

  const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
  const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const symbols = "!@#$%^&*()-_+=";

  let password = "";

  // Ensure at least one of each type of character
  password += getRandomChar(lowercaseChars);
  password += getRandomChar(uppercaseChars);
  password += getRandomChar(numbers);
  password += getRandomChar(symbols);

  // Fill the remaining characters randomly
  for (let i = 4; i < 12; i++) {
    const allChars = lowercaseChars + uppercaseChars + numbers + symbols;
    password += getRandomChar(allChars);
  }

  // Shuffle the password characters
  password = shuffleString(password);

  return password;
}

function addCustomErrors(div, text) {
  const formGroupErrorDiv = document.createElement("div");
  formGroupErrorDiv.classList.add(...["form__group__error", "custom-error"]);

  div.appendChild(formGroupErrorDiv);

  const pErrorDiv = document.createElement("small");
  pErrorDiv.classList.add("p-error");
  pErrorDiv.innerText = text;

  formGroupErrorDiv.appendChild(pErrorDiv);
}

// Remove custom errors
function removeCustomErrors(element) {
  const div = document.querySelector(element);

  if (div == undefined) {
    return;
  }

  // Remove .custom-error inside element if exists
  const deleteDivs = div.querySelectorAll(".custom-error");

  if (deleteDivs == undefined) {
    return;
  }

  deleteDivs.forEach((deleteDiv) => {
    deleteDiv.remove();
  });
}

// Validate GUID
function validateGUID(guid) {
  const regex =
    /^[A-F0-9]{8}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{12}$/i;

  return regex.test(guid);
}

function convertAliasToURL(alias, esPublico, showErrorToast = true) {
  // split alias spaces and replace them with "-"
  alias = alias.split(" ").join("-");

  // Add "/" at the start of the alias
  alias = `/${alias}`;

  // Check if the alias would be a valid url pathname
  const pathnameRegex = /^\/([a-zA-Z0-9-_]+\/?)*$/;

  // If the alias is not a valid url, show a error toast
  if (showErrorToast && !pathnameRegex.test(alias)) {
    localStorage.setItem("errorToastMessage", "El enlace no es válido");

    return;
  }

  // add window.location.origin to the alias
  alias = `${window.location.origin}/${
    esPublico ? "public" : "reports"
  }${alias}`;

  return alias;
}

function toggleElements(show, showFooter) {
  const navbar = document.querySelector(".navbar");
  const sidebar = document.querySelector(".sidebar");
  const footer = document.querySelector(".footer");

  if (navbar) {
    navbar.style.display = show ? "block" : "none";
  }

  if (sidebar) {
    sidebar.style.display = show ? "block" : "none";
  }

  if (footer) {
    footer.style.display = showFooter ? "block" : "none";
  }

  calculateBodyMinHeight();
}

function calculateBodyMinHeight() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const navbar = document.querySelector(".navbar");
      const footer = document.querySelector(".footer");

      if (navbar && footer) {
        clearInterval(interval);
        const headerHeight = navbar.getBoundingClientRect().height;
        const footerHeight = footer.getBoundingClientRect().height;

        let total = headerHeight + footerHeight;

        if (isNaN(total) || total == undefined || total == null) {
          total = 0;
        }

        document.documentElement.style.setProperty(
          "--header-footer-height",
          `calc(100dvh - ${total}px)`,
        );

        resolve();
      }
    });
  });
}

function disableAutocompleteForGlobalSearchInput() {
  const globalSearchContainer = document.querySelector(
    ".data-view__input__container",
  );

  if (globalSearchContainer) {
    const input = globalSearchContainer.querySelector("input");

    // Include the input in a form to disable autocomplete
    const form = document.createElement("form");
    form.appendChild(input);

    // Add the form to the container
    globalSearchContainer.appendChild(form);

    // Disable autocomplete
    form.setAttribute("autocomplete", "off");

    // Prevent form submit
    form.addEventListener("submit", (event) => {
      event.preventDefault();
    });
  }
}

function checkFormHasData(formData) {
  let hasData = false;

  if (
    formData &&
    Object.keys(formData).some((key) => {
      return formData[key];
    })
  ) {
    hasData = true;
  }

  return hasData;
}

function handleShowConfirm(confirm, showModalRef) {
  confirm.require({
    message: "El formulario contiene información, ¿desea cerrarlo?",
    header: "Cerrar formulario",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      showModalRef.value = false;
    },
  });
}

function showLoadingWhenDeletingRegister(deleteActionButton) {
  let deleteActionButtonHtml = null;

  if (!deleteActionButton.classList.contains("delete-action")) {
    deleteActionButton = deleteActionButton.closest(".delete-action");
  }

  if (deleteActionButton) {
    deleteActionButtonHtml = deleteActionButton.innerHTML;
    deleteActionButton.innerHTML = '<i class="pi pi-spin pi-spinner"></i>';
  }

  return { deleteActionButton, deleteActionButtonHtml };
}

export {
  formatDate,
  formatTime,
  convertLocalTimeToUtc,
  convertUtcToLocalTime,
  searchValue,
  isMobile,
  useSmallAddLabel,
  tableViews,
  downloadFile,
  createRandomPassword,
  addCustomErrors,
  removeCustomErrors,
  validateGUID,
  convertAliasToURL,
  toggleElements,
  disableAutocompleteForGlobalSearchInput,
  calculateBodyMinHeight,
  checkFormHasData,
  handleShowConfirm,
  showLoadingWhenDeletingRegister,
};
